import store from "./../store";

export default class {

  constructor(http){
    this.http = http;
  }

  //0 significa que esta fuera de hora
  //1 significa que non hay agentes disponibles
  //2 significa que no hay se paso del limite de la cola
  //3 significa que puede chatear

  newState(ontime, avaiableagents, avaiablesize){
    let state = 0;
    if (ontime){
      if(!avaiableagents) state = 1;
      else if(!avaiablesize) state = 2;
      else state = 3;
    }

    let savedstate = store.state.eventState;

    //si cambio el estado
    if(state !== savedstate){
      store.commit('setEventState', state);

      //si no es que esta disponible
      if(state !== 3){
        this.sendEvent(state);
      }
    }
  }

  sendEvent(state){
    this.http.get('https://' + store.state.configuration.ip + '/IntegraChannels/resources/webchat/sendEventLog', {
      params: {
        type: state,
        campaign: store.state.configuration.campaign,
        email: store.state.client.mail,
        name: store.state.client.name
      }
    }).then(e => {
      console.log(e);
    }, e => {
      //error
      console.log(e);
    });
  }

}
